import * as React from 'react';
import { GeoLocationModal } from '../../components/GeoLocationModal';
import { useDispatch, useSelector } from 'react-redux';
import { changeUrl, redirectUrl } from '../../../common/utils/changeUrl';
import { TThunkDispatch } from '../../../common/types/redux';
import { selectFilters } from '../../../common/selectors/filters';
import { selectRegions } from '../../../common/selectors/regions';
import { TRegion } from '../../../common/types/geoSwitcher';
import { setCurrentRegion } from '../../../common/actions/filters/setRegion';
import { IRegions } from '../../../common/types/regions';
import { getRegionWithoutCom } from '../../utils/getRegionWithoutCom';
import { useApplicationContext } from '../../utils/applicationContext';
import { setType } from '../../actions/filters/setRatingType';

type GeoLocationModalContainer = {
  modalIsOpen: boolean;
  handleOpenModal: VoidFunction;
  reload: boolean;
};

export const GeoLocationModalContainer: React.FC<GeoLocationModalContainer> = ({
  modalIsOpen,
  handleOpenModal,
  reload,
}) => {
  const dispatch = useDispatch<TThunkDispatch>();

  const allRegions = useSelector(selectRegions);
  const { type, region } = useSelector(selectFilters);

  const [visiblePopularRegions, setVisiblePopularRegions] = React.useState(true);
  const [regionInSearch, setRegionInSearch] = React.useState<IRegions[] | []>(allRegions ?? []);

  const { config } = useApplicationContext();

  const selectRegion = React.useCallback(
    (newRegion: TRegion) => {
      let typeRating = type;

      if (type === 'com' && getRegionWithoutCom(config, newRegion.slug)) {
        dispatch(setType('all'));

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        typeRating = 'all';
      }

      if (reload) {
        redirectUrl(typeRating, newRegion.slug);
      } else {
        handleOpenModal();

        dispatch(setCurrentRegion(newRegion));

        changeUrl(typeRating, newRegion.slug);

        document.title = `Рейтинг агентств недвижимости ${newRegion.titleForRender} по охвату на Циан`;
      }
    },
    [type, config, reload, dispatch, handleOpenModal],
  );

  const handleSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length === 0 && allRegions) {
      setRegionInSearch(allRegions);
    }
    if (e.target.value.length > 0) {
      setVisiblePopularRegions(false);
      const res =
        allRegions?.filter(elem => elem.displayName.toLowerCase().includes(e.target.value.toLowerCase())) ?? [];

      setRegionInSearch(res);
    } else {
      setVisiblePopularRegions(true);
    }
  };

  return (
    <GeoLocationModal
      onSearchValue={handleSearchValue}
      open={modalIsOpen}
      onClose={handleOpenModal}
      title={region.displayName}
      canVisiblePopularRegions={visiblePopularRegions}
      regions={regionInSearch}
      selectNewRegion={selectRegion}
    />
  );
};
